import React, {useState} from 'react';
import { withData } from '../../Data';
import useSort from '../../Hooks/useSort';
import history from '../../history';
import useFetchData from '../../crud/useFetchData';
import useSaveItem from '../../crud/useSaveItem';
import useDeleteItem from '../../crud/useDeleteItem';
import GrupoEmpresasEditUI from './GrupoEmpresasEditUI';
import {proto,url} from '../../Helpers/api';

const initial = {
  Cod: "",
  Nome: "",
  Membros: []
}

function useForm(object) {
  const [ Cod, setCod ] = useState(object.Cod)
  const [ Nome, setNome ] = useState(object.Nome)
  const [ Membros, setMembros ] = useState(object.Membros)
  const values = ["Cod","Nome","Membros"]
  const set = value => values.includes(value) ? eval(`set${value}`) : null
  return {
    values: { Cod, Nome, Membros },
    set
  }
}

const GrupoEmpresasEdit = props => {
  const { data:eData, match, refresh } = props;
  const { params={} } = match;
  const { cod } = params;
  const { empresas } = eData;
  const sort = useSort({by:"Codigo", list:empresas})
  const [ open, setOpen ] = useState(true)
  const closeDialog = () => {
    setOpen(false);
    history.push("/grpempresas");
  }
  let title, form, method, buttons = [];
  if (cod && cod !== "n") {
    // alterando grupo
    const item = useFetchData(`${proto}://${url}/grupos/mytest/${cod}`)
    // const item = useFetchData(`${proto}://${url}/main/mytest/${cod}`)
    if (item.isLoading) return <div>Carregando item...</div>;
    if (item.error) return <div>Erro ao carregar item! {item.error}</div>;
    const {data} = item;
    if (!item.isFinished || !data) return null;
    form = useForm(data);
    title = "Alterando Grupo de Empresas"
    buttons = [{
      disabled: () => save.isSaving && del.isDeleting,
      onClick: () => {
        save.saveData(form.values)
        refresh()
      },
      label: "Salvar Alterações"
    }, {
      disabled: () => save.isSaving && del.isDeleting,
      color: "secondary",
      onClick: () => {
        let {Cod} = form.values;
        if (window.confirm(`Tem certeza que deseja excluir o grupo de código ${Cod}`)) {
          del.deleteData(Cod)
          refresh()
        }
      },
      label: "Excluir Grupo"
    }]
    method = "PUT"
  } else if (cod === "n") {
    // criando novo grupo
    form = useForm(initial)
    title = "Criando Grupo de Empresas"
    buttons = [{
      disabled: () => save.isSaving,
      onClick: () => {
        save.saveData(form.values)
        refresh()
      },
      label: "Criar Grupo"
    }, {
      color: "primary",
      onClick: () => {
        closeDialog();
      },
      label: "Cancelar"
    }]
  } else {
    return null
  }
  const save = useSaveItem({ url: `${proto}://${url}/grupos/mytest`, method, cb: () => closeDialog() })
  const del = useDeleteItem({ url: `${proto}://${url}/grupos/mytest/`, cb: info => {
    closeDialog()
    window.alert(`Grupo excluído!`)
  }})
  // item = {isLoading,isFinished,error,data=[]}
  // sort = { sortBy, desc, setSort, list }
  // save = {isSaving,isSaved,saveData,answer,error}
  return (
    <GrupoEmpresasEditUI
      buttons={buttons}
      title={title}
      form={form}
      sort={sort}
      lista={sort.list}
      dialog={{open,closeDialog}}
      // refresh={refresh}
      // save={save}
      // del={del}
      // cod={cod}
    />
  )
}

export default withData(GrupoEmpresasEdit)
